import React from 'react';
import ECharts from 'echarts-for-react';

const PieChart = ({ data, config, title }) => {
  const nameKey = config?.nameKey || (data?.length > 0 ? Object.keys(data[0])[0] : null);
  const valueKey = config?.valueKey || (data?.length > 0 ? Object.keys(data[0])[1] : null);

  if (!nameKey || !valueKey || !data || data.length === 0) {
    return <div className="text-sand-700 p-8 text-center">No data available</div>;
  }

  const pieData = data.map((item) => ({
    value: Number(item[valueKey]) || 0,
    name: String(item[nameKey]),
  }));

  const colors = ['#c67139', '#7a8a5e', '#8c491a', '#56633f', '#a19786', '#f6a06b'];

  const option = {
    title: {
      text: title || 'Pie Chart',
      textStyle: { color: '#201e1d' },
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: '#201e1d',
      borderColor: 'transparent',
      borderWidth: 0,
      borderRadius: 8,
      textStyle: { color: '#f5ead8' },
      formatter: '{b}: {c} ({d}%)',
    },
    series: [
      {
        name: valueKey,
        type: 'pie',
        radius: ['20%', '70%'],
        data: pieData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(32, 30, 29, 0.25)',
          },
        },
        itemStyle: {
          color: function (params) {
            return colors[params.dataIndex % colors.length];
          },
        },
        label: {
          color: '#201e1d',
        },
      },
    ],
  };

  return (
    <ECharts
      option={option}
      style={{ width: '100%', height: '400px' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default PieChart;
